import Header from "./components/Header";

function Layout({
  children,
  filters = false,
  handleGroupChange,
  handleCommunityChange,
  isCompactView,
  setIsCompactView,
}) {
  return (
    <div className="mx-auto flex w-full flex-col md:w-1/2">
      <Header
        filters={filters}
        handleGroupChange={handleGroupChange}
        handleCommunityChange={handleCommunityChange}
        isCompactView={isCompactView}
        setIsCompactView={setIsCompactView}
      />
      <div className={filters ? "mt-28" : "mt-14"} />
      {children}
    </div>
  );
}

export default Layout;
